/* global axios */
import ApiClient from './ApiClient';

// Aceleres — painel "Sessão expirada" (janela de 24h da API Oficial do WhatsApp).
// Endpoints account-scoped sob aceleres/conversations/:id.
class AceleresSessionAPI extends ApiClient {
  constructor() {
    super('aceleres/conversations', { accountScoped: true });
  }

  // Registra (idempotente) o aviso "Sessão expirada" no histórico quando o
  // atendente interage com o painel (Concluir/Transferir/Reiniciar).
  registerExpiryNotice(conversationId) {
    return axios.post(`${this.url}/${conversationId}/session_expired_notice`);
  }

  // Reabre o atendimento após a expiração: status=open + destrava o composer
  // por 24h (aceleres_session_restarted_at). Backend valida se a instância
  // está marcada como API Oficial com Reiniciar liberado pelo gestor.
  restartSession(conversationId) {
    return axios.post(`${this.url}/${conversationId}/restart_session`);
  }
}

export default new AceleresSessionAPI();
